<template>
  <div>
    <div class="Navbar0">
      <el-popover visible-arrow trigger="click" placement="left-end">
        <div class="Navbar1" slot="reference">
          友情链接展示区
          <img
            slot="reference"
            src="../../../assets/services/sanjiao.png"
            class="img"
          />
        </div>
        <div class="triangle" v-for="(list, i) in message.links">
          {{ list.title }}</br>
          <a :href="list.urls" class="link">
          {{ list.urls }}
          </a>
        </div>
      </el-popover>
      <hr class="hr" />
      <div class="Navbar2">
        <router-link to="/contact" class="link">
          <span class="iconfont icon-phone NavSpan"></span
          ><span class="NavSpan">联系我们</span>
        </router-link>
        <router-link to="/map/about" class="link">
          <span class="iconfont icon-site NavSpan"></span
          ><span class="NavSpan">站点地图</span>
        </router-link>
        <router-link to="/statement/legal" class="link">
          <span class="iconfont icon-law NavSpan"></span
          ><span class="NavSpan">法律声明</span>
        </router-link>
        <router-link to="/statement/privacy" class="link" title="隐私保护">
          <span class="iconfont icon-lock NavSpan"></span
          ><span class="NavSpan">隐私保护</span>
        </router-link>
      </div>
      <div class="Navbar4">
        <span class="NavSpan3">{{
          this.message.title
            ? this.message.title
            : "北京清大天达光电科技股份有限公司"
        }}</span
        ><br />
        <span class="NavSpan3"
          >地址：{{
            this.message.address
              ? this.message.address
              : "北京市平谷区马坊镇金马北街61号院2号楼1至2层101"
          }}
        </span>
      </div>
      <div class="Navbar3">
        <span class="NavSpan2"
          >@北京清大天达光电科技股份有限公司版权所有<br/>
          {{ this.message.icp }}</span
        ><br/>
        <span class="NavSpan2">公安网备 11011702000498号</span>
        <div style="background-color: #f5f5f5; height: 0.3125rem"></div>
        <div class="NavSpan4" v-if="this.message.p_code !== null">
          <img :src="record" style="width: 1.25rem; height: 1.25rem" />
          <span class="NavSpan2">{{'京公安网备 ' + this.message.p_code}}</span>
          <span class="NavSpan2">公网安备 11011702000498号</span>
        </div>
        <div style="background-color: #f5f5f5; height: 1.5625rem"></div>
      </div>
    </div>
  </div>
</template>

<script>
import record from '@/assets/img/record.png'
import api from '@/utils/api'
export default {
  name: 'Navbar',
  props: {
    message: {
      type: Object,
    },
  },
  mounted () {
  },
  data () {
    return {
      record: record,
      //   lists: [
      //     { id: 1, url: '网址1' },
      //     { id: 2, url: '网址2' },
      //     { id: 3, url: '网址3' },
      //     { id: 3, url: '网址3网址3网址3网址3网址3' },
      //   ],
    }
  },
}
</script>
<style>
/* 点击三角出现拓展的位置,这个样式是全局样式不能在scoped下面 */
.el-popover {
  width: 28.75rem !important;
  margin-left: 8.125rem !important;
}
</style>

<style scoped>
/*底部栏*/
/deep/ .hr {
  width: 30rem;
  margin-left: auto;
  margin-right: auto;
}

/* 图片 */
.img {
  width: 1.25rem;
  height: 1rem;
}
/deep/ .link {
  color: #666666;
  text-decoration: none;
}
.Navbar0 {
  background-color: #f5f5f5;
  /* height: 400px; */
}
.Navbar1 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 2.125rem;
  color: #666666;
  margin-bottom: 0.5rem;
  text-align: center;
}
.Navbar2 {
  text-align: center;
  margin-top: 0.5rem;
  margin-bottom: 4rem;
}
.Navbar3 {
  text-align: center;
  margin-bottom: 2.25rem;
  /* height: 15rem; */
}
.Navbar4 {
  text-align: center;
  margin-bottom: 0.5rem;
}
.NavSpan {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 1.5rem;
  line-height: 2.125rem;
  color: #666666;
  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 0rem 0.25rem;
}
.NavSpan2 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 1.25rem;
  line-height: 1.75rem;
  text-align: center;
  margin-bottom: 0.5rem;
  color: #bebebe;
}
.NavSpan3 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 1.25rem;
  line-height: 2.375rem;
  text-align: right;
  color: #666666;
}
.triangle{
  font-size: 1.75rem;

}
</style>
